/**
 * 任务状态
 */
export enum TaskStatus {
    /**
     * 未开始
     */
    READY = 'Ready',
    /**
     * 处理中
     */
    PROCESSING = 'Running',
    /**
     * 已完成
     */
    COMPLETED = 'Complete',
    /**
     * 失败
     */
    FAILED = 'Failed',
    /**
     * 已中断
     * @description 任务被手动取消
     */
    INTERRUPTED = 'Interrupt',
    /**
     * 数据版本过期
     */
    DATA_VERSION_EXPIRED = 'DataVersionExpired',
}

export enum TaskType {
    TRANSLATION = 'translation',
    SPECIFICATION = 'specification',
    DISCLOSURE = 'disclosure',
    NOVELTY_SEARCH = 'novelty-check-report',
    FTO_SEARCH = 'fto-report',
    NEW_FTO_SEARCH = 'fto-pro',
    PROOF_READING = 'proof-reading',
    AI_OAR = 'oar',
    HIRO_SUPER_AGENT = 'hiro',
    EOU_AGENT = 'eou-agent',
}
